import { normalize } from 'normalizr';

import { getUserClasses, editClass, createClass, deleteClass } from '../../../../api/educatorClasses';
import { classSchema } from './schema';

import * as types from './types';

const normalizeClasses = data => normalize(
  data,
  Array.isArray(data)
    ? [classSchema]
    : classSchema,
).entities.classes || {};

export const getUserClassesAction = () => ({
  type: types.CLASSES_GET,
  payload: async () => normalizeClasses(await getUserClasses()),
});

export const editClassAction = ({ classId, name, inviteCode }) => ({
  type: types.CLASSES_EDIT,
  payload: async () => normalizeClasses(await editClass(classId, {
    name, inviteCode,
  })),
  meta: { classId, name },
});

export const createClassAction = ({ name, inviteCode }) => ({
  type: types.CLASSES_CREATE,
  payload: async () => normalizeClasses(await createClass({ name, inviteCode })),
  meta: { name },
});


export const deleteClassAction = ({ classId }) => ({
  type: types.CLASSES_DELETE,
  payload: async () => normalizeClasses(await deleteClass(classId)),
  meta: { classId },
});
